/* Copyright IBM Corp. 2017 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { WchService } from './../wch.service';
import { ApplicationConfig } from './application.config';

/*
 * Represents the application configuration
 */
@Injectable({ providedIn: 'root' })
export class ApplicationConfigService {

    constructor(private wchService: WchService) {
    }

    get appConfig(): Observable<ApplicationConfig> {
        return this.wchService.getAppConfig();
    }
}
